let is_numeric = (value) => {
    return !isNaN(+value);
}

export default is_numeric;
